export default ({message, title, wrapContent = true}) => (
  <div className="alert alert-warning cb-alert-heading" role="alert" tabIndex="0">
    <h2>{title || 'Warning'}</h2>
    {wrapContent
      ? <p>{message}</p>
      : <>{message}</>
    }
  </div>
)